<template>
  <div v-if="dashboard_data.total_sales!=null">
    <WidgetsDropdown :info="dashboard_data"/>
    <CRow class="mb-4">
      <CCol md="12">
        <ReservationCalendar :reservations="dashboard_data.last_orders || []"/>
      </CCol>
    </CRow>
<!--    <CRow>-->
<!--      <CCol md="12">-->
<!--        <CCard>-->
<!--          <CCardHeader>-->
<!--            {{$t('reservations')}}-->
<!--          </CCardHeader>-->
<!--          <CCardBody>-->

<!--            <br/>-->
<!--            <CDataTableFixed-->
<!--                class="mb-0 table-outline"-->
<!--                hover-->
<!--                striped-->

<!--                :items="dashboard_data.last_orders"-->
<!--                :fields="orderFields"-->
<!--                head-color="light"-->
<!--                no-sorting-->
<!--            >-->


<!--              <template #line="{item}">-->
<!--                <td>-->
<!--                  <div class="clearfix">-->
<!--                    <div class="float-left">-->
<!--                      <strong>{{ item.line.title }}-->
<!--                      {{item.admin.name}}</strong>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </td>-->

<!--              </template>-->

<!--              <template #created_at="{item}">-->
<!--                <td>-->
<!--                  <p>{{ get_date_time(item.reserve_time.date) }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #table_id="{item}">-->
<!--                <td>-->
<!--                  <p>{{ (item.table.title) }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #name="{item}">-->
<!--                <td>-->
<!--                  <p>{{ item.user.name }}</p>-->
<!--                </td>-->
<!--              </template>-->
<!--              <template #total_price="{item}">-->
<!--                <td>-->
<!--                  <p>{{ get_currency(item.total_price) }}</p>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #operation="{item}">-->
<!--                <td>-->
<!--                  <CButton-->
<!--                      color="info"-->
<!--                      @click="$router.push('/dashboard/orders/info/'+item.id)"-->
<!--                  >-->
<!--                    <CIcon name="eye"/>-->
<!--                  </CButton>-->
<!--                </td>-->

<!--              </template>-->

<!--            </CDataTableFixed>-->
<!--          </CCardBody>-->
<!--        </CCard>-->
<!--      </CCol>-->
<!--    </CRow>-->

    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="5">
            <h4 id="traffic" class="card-title mb-0">{{ $t('reservation_chart') }}</h4>
          </CCol>
          <CCol col="7" class="d-none d-md-block">

            <CButtonGroup class="float-right mr-3">
              <CButton
                  color="outline-secondary"
                  v-for="(value, key) in reservation_chart_titles"
                  :key="key"
                  class="mx-0"
                  :pressed="value === selected_sale_time ? true : false"
                  @click="selected_sale_time = value"
              >
                {{ value }}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <NewChartJs
            v-if="dashboard_data.dashboard_daily_report"
            type="bar"
            :label="$t('reserve')"
            :info="dashboard_data.dashboard_daily_report"
            style="height:300px;margin-top:40px;"/>

      </CCardBody>

    </CCard>
    <!--    <WidgetsBrand/>-->
  </div>
</template>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'
import ReservationCalendar from './widgets/ReservationCalendar'
import axios from "axios";
import NewChartJs from "@/views/charts/NewChartJs.vue";
import {bus} from "../main";

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    NewChartJs,
    ReservationCalendar
  },
  data() {
    return {
      reservation_chart_titles:[this.$t('daily'), this.$t('monthly'), this.$t('yearly')],
      selected_sale_time: this.$t('daily'),
      selected_products_time: this.$t('daily'),


      orderFields: [
        {key: 'id', label: '#', _classes: 'text-center'},
        {key: 'name', label: this.$t('customer')},
        {key: 'created_at', label: this.$t('submit_date'), _classes: 'text-center'},
        {key: 'line', label: this.$t('line'), _classes: 'text-center'},
        // {key: 'operation', label: 'عملیات'},
      ],
      dashboard_data: {},
    }
  },
  mounted() {
    this.get_dashboard_data();
    var self = this
    bus.$on('get_dashboard_data', (data) => {
      self.get_dashboard_data();
    });
  },
  methods: {

    get_dashboard_data() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();

      axios.post('/api/admin/dashboard_data', formData, {}).then(function (response) {

        var contents = response.data;

        self.dashboard_data = contents;

      })
          .catch(function (error) {
            console.log(error);
          });

    },
  }
}
</script>
